export default {
    getIfNotNull(value) {
        if (value == null || value == undefined || value == '') {
            return '';
        }
        return value;
    }
}

export const dateLocale = 'DD-MM-YYYY';
export const dateLocaleBG = 'DD.MM.YYYY';

export const serverDateLocale = "X";

const locales = {
    bg: { format: "bg-BG", currency: "BGN" },
    en: { format: "en-GB", currency: "GBP" }
}

export const formatCurrency = (number, localization) =>
    new Intl.NumberFormat(locales[localization].format, {
        style: 'currency',
        currency: locales[localization].currency
    }).format(number)


export let getEmptyTripData = () => {
    return {
        "id": null,
        "key": null,
        "title": "",
        "startDate": null,
        "endDate": null,
        "participants": null,
        "price": null,
        "deposit": null,
        "destinationType": null,
        "requirePassport": null,
        "requireVisa": null,
        "tripDetails": "",
        "tripContractTemplate": ""
    }
}

export let isExpiringSoon = (tripMomentDate,expirationMomentDate)=>{
    return expirationMomentDate.diff(tripMomentDate,"months") < 6;
}

export function fallbackCopyTextToClipboard(text) {
    var textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position="fixed";  //avoid scrolling to bottom
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
  
    try {
      var successful = document.execCommand('copy');
      var msg = successful ? 'successful' : 'unsuccessful';
      console.log('Fallback: Copying text command was ' + msg);
    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err);
    }
  
    document.body.removeChild(textArea);
  }

export function copyTextToClipboard(text) {
    if (!navigator.clipboard) {
      fallbackCopyTextToClipboard(text);
      return;
    }
    navigator.clipboard.writeText(text).then(function() {
      console.log('Async: Copying to clipboard was successful!');
    }, function(err) {
      console.error('Async: Could not copy text: ', err);
    });
}

export function convertCSVToSpreadSheetObject (header, json) {
  // csv is array
  let realHeaders = []
  header.map(item => realHeaders.push(item.label))

  let items = json.map(item => {
    let newObj = []
    header.map(header => {
      let prop = header.key
      if (item.hasOwnProperty(prop)) {
        newObj.push(item[prop])
      } else {
        newObj.push('')
      }
    })
    return newObj
  })
  return [realHeaders, ...items]
}

export let isEmptyString = (text)=>{
    return text.lenght == 0;
}